import React from 'react';
import PropTypes from 'prop-types';
import { TwoPartHeaderCell } from '../../../../../../../components/cell/shared/Cells';
import { generateReactKey } from '../../../../../../../utils/shared/commonUtils';

const TableHeader = ({ titles }) => (
    <div className="table-row header-row">
        {titles.map(({ firstPart, secondPart, className, cellClassName }, index) => (
            <div key={generateReactKey(index)} className={`book-cell ${className}`}>
                <TwoPartHeaderCell
                    classNames={cellClassName}
                    firstPartTitle={firstPart}
                    secondPartTitle={secondPart}
                />
            </div>
        ))}
    </div>
);

export default TableHeader;

TableHeader.defaultProps = {
    titles: [],
};

TableHeader.propTypes = {
    titles: PropTypes.array,
};
